import React from "react";
import {IntlShape} from "react-intl";

import {ICycleDuration, ISopModel} from "../models";
import {ISopLimits} from "../wizard/models";

import T, {intl2Str} from "@translate/T";

export function getNormalizationText(value: ISopModel) {
    return value.forceNewNormalizations ? (
        <T>Recorded before measurement</T>
    ) : (
        <T>Reuse existing normalizations</T>
    );
}

export function getNormalizationTooltip(intl: IntlShape) {
    return intl2Str(
        intl,
        "Normalization can be re-used, if available and not older than 28 days. Otherwise normalization will be recorded always.",
    );
}

export function getCycleDurationWarning(
    intl: IntlShape,
    duration: ICycleDuration,
    limits: ISopLimits,
    cycleInterval: number,
) {
    let title;
    let className = "align-middle";
    if (duration.limitedSchedule) {
        title = intl2Str(
            intl,
            "SOP runs longer due to recording schedule dependence on the rotor speed.",
        );
        className += " is-invalid-warning";
    }

    //display warning for network device on delayed sync for short interval
    if (cycleInterval < limits.minSendInterval) {
        title = intl2Str(
            intl,
            "Sync of profiles from device to SEPView will be delayed until cycle with an interval equal or greater than {minSendInterval} seconds, or at the end of measurement.",
            {minSendInterval: limits.minSendInterval},
        );
        className += " is-invalid-warning";
    }

    return {title, className};
}
